export const DAILY_RENT_SEARCH_URL = 'cian.ru/snyat-kvartiru-posutochno/';
